import storage from "redux-persist/lib/storage";

export const Config = {
    version: 0,
    key: "goal",
    storage,
    debug: process.env.NODE_ENV === "development",
    whietelist: [],
    blacklist: ["router", "modal", "profession", "school", "search", "main"]
};
